<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import { user } from "../../stores";

    import { PageLoading } from "../../Components/Common/index.svelte";

    import OverviewTab from "./components/OverviewTab.svelte";
    import SettingsTab from "./components/SettingsTab.svelte";
    import UserAccountTab from "./components/UserAccountTab.svelte";

    import { replaceURL } from "../../Utils/utilFunctions.svelte";

    export let params = {};

    let isLoadingUser = false,
        userDetails = {},
        userAccounts = [],
        selectedUserAccountId = Number(0),
        currentTab = "";

    onMount(() => {
        _updateTab(params.query);

        loadUser($user.id);
    });

    const loadUser = async (id) => {
        isLoadingUser = true;

        await apiMethods.getMethod.getUserById(id).then((res) => _setUser(res));

        isLoadingUser = false;
    };

    const goToOverview = async (reloadUser = false) => {
        currentTab = "overview";
        selectedUserAccountId = Number(0);
        _updateUrlByTab();

        reloadUser && (await loadUser($user.id));
    };

    const goToSettings = () => {
        currentTab = "settings";
        selectedUserAccountId = Number(0);
        _updateUrlByTab();
    };

    const handleTabByUserAccountId = (id) => {
        selectedUserAccountId = Number(id);

        currentTab = `userAccount${id}`;
        _updateUrlByTab();
    };
    // HELPER FUNCTIONS
    const _setUser = (res) => {
        userDetails = { ...res };
        userAccounts = [...res.userAccounts];

        if (currentTab.includes("userAccount"))
            selectedUserAccountId = currentTab.replace("userAccount", "");
    };

    const _updateUrlByTab = () => {
        replaceURL(`/profile/current=${currentTab}`);
    };

    const _updateTab = (query) => {
        if (query) currentTab = query.split("=")[1];
        else currentTab = "overview";
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    {#if isLoadingUser}
        <PageLoading />
    {:else}
        <div class="flex flex-1 flex-col shadow-2xl rounded-lg bg-white">
            <div class="tabs m-4">
                <div
                    class={currentTab == "overview"
                        ? "tab tab-bordered tab-active"
                        : "tab tab-bordered"}
                    on:click={goToOverview}
                >
                    Overview
                </div>
                <div
                    class={currentTab == "settings"
                        ? "tab tab-bordered tab-active"
                        : "tab tab-bordered"}
                    on:click={goToSettings}
                >
                    User Settings
                </div>

                {#if userAccounts.length}
                    {#each userAccounts as { id, titleName, fullName }}
                        <div
                            class={currentTab == `userAccount${id}`
                                ? "tab tab-bordered tab-active"
                                : "tab tab-bordered"}
                            on:click={() => handleTabByUserAccountId(id)}
                        >
                            {`${titleName} ${fullName}`}
                        </div>
                    {/each}
                {/if}
            </div>

            <div class="relative flex-1">
                <div
                    class="overflow-y-auto absolute inset-0 bg-white rounded-lg"
                >
                    {#if currentTab == "overview"}
                        <OverviewTab
                            {userDetails}
                            goToSettingsFunc={goToSettings}
                        />
                    {:else if currentTab == "settings"}
                        <SettingsTab
                            {userDetails}
                            goToOverviewFunc={() => goToOverview(true)}
                        />
                    {:else if currentTab.includes("userAccount")}
                        <UserAccountTab userAccountId={selectedUserAccountId} />
                    {/if}
                </div>
            </div>
        </div>
    {/if}
</div>
